import { LatLng, distanceTo } from "geolocation-utils";

import { IPlace, Iterable } from "types";
import { AvoidType } from "constants/enums";

export const isEqualLatLng = (a?: LatLng, b?: LatLng) => {
  if (!a) return false;
  if (!b) return false;

  return a.lat === b.lat && a.lng === b.lng;
};

export const sortByDistance = (
  start: LatLng,
  finish: LatLng,
  coordinates: LatLng[]
) => {
  const coords = coordinates.sort((a, b) => {
    const aDistanceToStart = distanceTo(a, finish);
    const bDistanceToStart = distanceTo(b, finish);

    return bDistanceToStart - aDistanceToStart;
  });

  return [start, ...coords, finish];
};

export const convert = {
  points: {
    toLatLng: (values: number[][]) =>
      values.map((item) => ({
        lat: item[1],
        lng: item[0],
      })),
  },

  point: {
    toLatLng: (value: number[]) => ({
      lat: value[1],
      lng: value[0],
    }),
    toLatLon: (value: number[]) => ({
      lat: value[1],
      lon: value[0],
    }),
  },

  latLng: {
    toLatLon: (value: LatLng) => ({ lat: value.lat, lon: value.lng }),
    toPoint: (value: LatLng) => [value.lng, value.lat] as number[],
  },
};

export const getGoogleMapsLink = (
  places: (Iterable<IPlace> | undefined)[],
  waypoints: LatLng[],
  options?: { avoid: (keyof typeof AvoidType)[] }
) => {
  // let scheme = "comgooglemapsurl://www.google.com/maps/dir/?api=1";
  /*
  let scheme = "https://www.google.com/maps/dir/?api=1";

  let origin = "";
  let destination = "";
  let routeWaypoints: string[] = [];

  for (const [index, waypoint] of waypoints.entries()) {
    if (index === 0) {
      const place = places.at(index);
      origin = place
        ? `${place.title},${place.address_info.city}`
        : `${waypoint.lat},${waypoint.lng}`;
      continue;
    }

    if (index === waypoints.length - 1) {
      const place = places.at(waypoints.length - 1);
      destination = place
        ? `${place.title},${place.address_info.city}`
        : `${waypoint.lat},${waypoint.lng}`;
      continue;
    }

    const place = places.at(index);
    routeWaypoints.push(
      place
        ? `${place.title},${place.address_info.city}`
        : `${waypoint.lat},${waypoint.lng}`
    );
  }

  if (origin) scheme += `&origin=${encodeURI(origin)}`;
  if (destination) scheme += `&destination=${encodeURI(destination)}`;
  if (routeWaypoints.length > 0)
    scheme += `&waypoints=${encodeURI(routeWaypoints.join("|"))}`;

  scheme += `&dirflg=h,t`;

  return scheme;
*/
  let scheme = "http://maps.google.com/maps?";

  let origin = "";
  let routeWaypoints: string[] = [];

  for (const [waypointIndex, waypoint] of waypoints.entries()) {
    const place = places.at(waypointIndex);

    const name = place
      ? `${place.title},${place.address_info.city},${place.address_info.country_code},${place.address_info.zip}`
      : `${waypoint.lat},${waypoint.lng}`;

    /* Origin */
    if (waypointIndex === 0) {
      origin = name;
      continue;
    }

    routeWaypoints.push(name);
  }

  if (origin) scheme += `saddr=${encodeURI(origin)}`;
  if (routeWaypoints.length > 0) {
    routeWaypoints.forEach((name, index) => {
      scheme +=
        index === 0 ? `&daddr=${encodeURI(name)}` : `+to:${encodeURI(name)}`;
    });
  }

  if (options && options.avoid.length > 0) {
    const avoids: string[] = [];

    if (options.avoid.includes(AvoidType.MOTORWAY)) {
      avoids.push("h");
    }
    if (options.avoid.includes(AvoidType.TOLL)) {
      avoids.push("t");
    }

    // TODO: Can not find keyword for FERRIES;

    if (avoids.length > 0) {
      scheme += `&dirflg=${avoids.join(",")}`;
    }
  }

  return scheme;
};
